export default __webpack_public_path__ + "static/niche@mob_2x-b47c341917b24c7e0cc39f487985c986.webp";